<template>

  <div>
    <v-layout class="banner">
      <div class="intro-computer"></div>
    </v-layout>
    <v-container class="intro">
      <v-row>
        <v-col cols="12">
          <div class="inner">
            <h1>Big Software <br> for Small Business</h1>
            <router-link to="contact" class="btn">Get Started</router-link>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'Intro',

  data: () => ({
    
  }),
};
</script>
